@if (icon() || description()) {
    <span class="flex items-center gap-2 min-w-0" [tooltip]="description() ?? ''" [position]="TooltipPosition.RIGHT">
        @if (icon()) {
            <img [src]="icon()" alt="" class="h-5 w-5 shrink-0 filter-primary-purple" />
        }
        <span class="block truncate" [innerHTML]="label() ?? ''"></span>
    </span>
} @else {
    <span #optionLabel class="block truncate" [innerHTML]="label() ?? ''" [tooltip]="label() ?? ''" [visibleTooltip]="optionLabel"></span>
}
